import Vue from 'vue'
import VueRouter from 'vue-router'
import PagePreLogin from '../views/PagePreLogin.vue'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'pre-login',
    component: PagePreLogin
  },
  {
    path: '/login/:type',
    name: 'login',
    component: () => import('@/views/PageLogin'),
    props: true
  },
  {
    path: '/rotas',
    name: 'rotas-login',
    component: () => import('@/views/PageLoginRotas')
  },
  {
    path: '/exames-rotas',
    name: 'exames-rotas',
    component: () => import('@/views/PageExamesRotas'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/exames',
    name: 'exames',
    component: () => import('@/views/PageExames'),

    meta: {
      requiresAuth: true
    },

    children: [
      {
        path: 'medico',
        name: 'medico',
        component: () => import('@/views/PageExamesMedico')
      },
      {
        path: 'paciente',
        name: 'paciente',
        component: () => import('@/views/PageExamesPaciente')
      },
      {
        path: 'empresa',
        name: 'empresa',
        component: () => import('@/views/PageExamesEmpresa')
      }
    ]
  },
  {
    path: '*',
    name: '',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.commit('startGlobalLoading')

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (!requiresAuth) next()
  else if (store.state.validCredentials) {
    next()
  } else {
    next({ name: 'pre-login' })
    store.commit('stopGlobalLoading')
  }
})

router.afterEach((to, from) => {
  store.commit('stopGlobalLoading')
})

export default router
